// Assume these are not only popup layers, but also notification layers and maybe something else's layers
export * from '@core/js/components/common/PopupManager/layers';

export const LAYER = {
    ADVANCED_PLAYER_MESSAGE: 'ADVANCED_PLAYER_MESSAGE',
    ADVANCED_PLAYER_MESSAGE_MODAL: 'ADVANCED_PLAYER_MESSAGE_MODAL',
    CARD: 'CARD',
    COMMON: 'COMMON',
    HIGH_PRIORITY: 'HIGH_PRIORITY',
    NOTIFICATION: 'NOTIFICATION',
    BONUS_LOW: 'BONUS_LOW',
    BONUS: 'BONUS',
    QUICK_DEPOSIT: 'QUICK_DEPOSIT',
    GAMES_INFO: 'GAMES_INFO',
    LIGHTBOX: 'LIGHTBOX',
    TIME_IS_FLYING: 'TIME_IS_FLYING',
    LOGIN: 'LOGIN',
    LOGIN_MESSAGES: 'LOGIN_MESSAGES',
    LOGOUT_MESSAGES: 'LOGOUT_MESSAGES',
    SESSION_VALIDATION: 'SESSION_VALIDATION',
    DATA_VERIFICATION: 'DATA_VERIFICATION',
    MULTIVIEW_BONUS_TC: 'MULTIVIEW_BONUS_TC',
    MULTIVIEW_BONUS: 'MULTIVIEW_BONUS',
    JUMIO: 'JUMIO',
    GAMBLING_SESSION: 'GAMBLING_SESSION',
    IFEELLUCKY: 'IFEELLUCKY',
    EXPANDED_CATEGORY_POPUP: 'EXPANDED_CATEGORY_POPUP'
};

// All known visibility layers. The lower the index, the lower the layer visually.
export const LAYERS_ORDER = [
    LAYER.IFEELLUCKY,
    LAYER.EXPANDED_CATEGORY_POPUP,
    LAYER.CARD,
    LAYER.QUICK_DEPOSIT, // quick deposit popup
    LAYER.GAMES_INFO, // games info popup
    LAYER.ADVANCED_PLAYER_MESSAGE, // 31133 - ActionShowAdvancedDialogInfo
    LAYER.ADVANCED_PLAYER_MESSAGE_MODAL, // 31133 - ActionShowAdvancedDialogInfo {isModal:true}
    LAYER.MULTIVIEW_BONUS, // bonusmultiview
    LAYER.MULTIVIEW_BONUS_TC, // bonusmultiview: T&C popup from bonus details popup
    LAYER.COMMON, // all popups by default go here
    LAYER.BONUS_LOW, // notification bonus popups (usually with OK button)
    LAYER.BONUS, // 33005 - popups with confirmation, more important

    LAYER.NOTIFICATION, // "toast" notifications
    LAYER.LIGHTBOX, // popup with iframe in it for redirection calls
    LAYER.TIME_IS_FLYING,
    LAYER.LOGIN, // login popup
    LAYER.GAMBLING_SESSION, // Spanish regulations: GamblingSessionLimits, 60-minutes Interval Message
    LAYER.JUMIO, // JumioVerifyPopup
    LAYER.DATA_VERIFICATION, // dataVerificationStatus popup
    LAYER.SESSION_VALIDATION, // 2FA, FitToPlay, PIN verification
    LAYER.LOGIN_MESSAGES, // waiting messages after login
    LAYER.HIGH_PRIORITY, // legacy 'high priority' popups
    LAYER.LOGOUT_MESSAGES // messages that arrive during logout notification with closeClient=1 have to be shown first
];

export const getLayerId = (layer = 0) =>
    Number.isFinite(layer)
        ? layer
        : LAYERS_ORDER.indexOf(layer) * 1000;
